import { useOrganisation } from "@/contexts/OrganisationContext";
import { FEATURE_PLAN_LABELS, type FeatureKey } from "@/lib/features";

export function useFeatureGate(feature: FeatureKey) {
  const { activeOrg, isLoading } = useOrganisation();

  const features = (activeOrg as unknown as Record<string, unknown>)
    ?.features as string[] | undefined;
  const hasFeature = features?.includes(feature) ?? false;
  const requiredPlan = FEATURE_PLAN_LABELS[feature] ?? "a higher";
  // Treat "org still loading" as unknown — callers should avoid rendering an
  // upgrade prompt before the answer is definitive, or the user will see a
  // brief flash of "upgrade required" while the org context populates.
  const isResolving = isLoading || !activeOrg;

  return { hasFeature, requiredPlan, isResolving };
}
